export default [
    {
      path: '/fieldServices/installation/list',
      name: 'fieldServices.installation.list',
      component: () => import('@/views/modules/fieldServices/installation/list.vue'),
      meta: {
        module: 'fieldServices.installation',
        pageTitle: 'FIELD_SERVICES_INSTALLATION_LIST_TITLE',
        breadcrumb: [
          { text: 'FIELD_SERVICES_INSTALLATION_LIST_TITLE', active: true}
        ],
      }
    },
    {
      path: '/fieldServices/installation/create',
      name: 'fieldServices.installation.create',
      component: () => import('@/views/modules/fieldServices/installation/create.vue'),
      meta: {
        module: 'fieldServices.installation',
        pageTitle: 'FIELD_SERVICES_INSTALLATION_CREATE_TITLE',
        breadcrumb: [
          { text: 'FIELD_SERVICES_INSTALLATION_LIST_TITLE', to: { name: 'fieldServices.installation.list'} },
          { text: 'FIELD_SERVICES_INSTALLATION_CREATE_TITLE', active: true}
        ],
      }
    },
    {
      path: '/fieldServices/installation/:id/details',
      name: 'fieldServices.installation.show',
      component: () => import('@/views/modules/fieldServices/installation/details.vue'),
      meta: {
        module: 'fieldServices.installation',
        pageTitle: 'FIELD_SERVICES_INSTALLATION_DETAILS_TITLE',
        breadcrumb: [
          { text: 'FIELD_SERVICES_INSTALLATION_LIST_TITLE', to: { name: 'fieldServices.installation.list'} },
          { text: 'FIELD_SERVICES_INSTALLATION_DETAILS_TITLE', active: true}
        ],
      }
    }
    
  ]
  